const color = {
  FB_THEME: '#0084ff',
  FB_BUBBLE: '#0099ff',
  LINE_THEME: '#00c300',
  LINE_BUBBLE: '#84e884',
  APP_THEME: '#1c70b0',
}

export default color
